import { Form, Formik } from 'formik';
import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import TextField from '@components/Form/TextField';
import { useUserInfoUpdate } from '@hooks';

import schema from './schema';
import styles from './styles.module.css';

interface InitialStateProps {
  name: string;
  email: string;
  password?: string;
  passwordConfirmation?: string;
}

const BasicInfoForm = ({
  initialState,
  loginLinkOnly,
  ReadOnlyMode,
}: {
  initialState: InitialStateProps;
  loginLinkOnly: boolean;
  ReadOnlyMode: string;
}) => {
  const { mutate: updateUser } = useUserInfoUpdate();

  const handleSubmit = (values: InitialStateProps, { setSubmitting }) => {
    delete values['passwordConfirmation'];
    updateUser({ user: values });
    setSubmitting(false);
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      initialValues={initialState}
      validationSchema={schema}
    >
      {(formik) => (
        <Form>
          <TextField className="mb-24" name="name" placeholder="Name" />
          <TextField className="mb-24" name="email" placeholder="email" />
          {!loginLinkOnly && (
            <>
              <TextField
                className="mb-24"
                name="password"
                placeholder="Password (leave blank if you do not wish to change)"
                type="password"
              />
              <TextField
                className="mb-24"
                name="passwordConfirmation"
                placeholder="Confirm Password"
                type="password"
              />
            </>
          )}
          {!ReadOnlyMode && (
            <div className={styles.submitBtnContainer}>
              <PrimaryButton
                as="button"
                type="submit"
                disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
                isLoading={formik.isSubmitting}
                fullWidth
              >
                Submit
              </PrimaryButton>
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default BasicInfoForm;
